exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-alert-message{padding-right:16px}.ba-alert-message,.ba-alert-message .ba-message-container{display:flex;align-items:center;flex-grow:1}.ba-alert-message .ba-message-container .ba-optional-title{font-weight:600;padding:0 16px 0 8px}.ba-alert-message .ba-message-container .ba-common-svgIcon{min-width:16px}.ba-alert-message .ba-dismiss-container .ba-common-link{color:#fff}.ba-alert-message .ba-dismiss-container .ba-common-link:hover{color:#eaeaea}", ""]);

// exports
exports.locals = {
	"toolTipIconClassName": "\"ba-common-svgIcon\"",
	"alertMessageClassName": "\"ba-alert-message\"",
	"messageContainerClassName": "\"ba-message-container\"",
	"dismissContainerClassName": "\"ba-dismiss-container\"",
	"optionalTitleClassName": "\"ba-optional-title\""
};